function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { MarkdownEl } from "common/components/markdown";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { ButtonBarEl } from "common/components/button-bar";
import { ButtonBarTheme } from "common/components/button-bar/types";
import { DropMenuEl } from "common/components/drop-menu";
import { Directions } from "common/components/drop-menu/types";
import { InputEl } from "common/components/input";
import { InputGroupEl } from "common/components/input-group";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { TargetProjectSelectorMenuEl } from "common/widgets/target-project-selector-menu";
import { ListItemEl } from "common/components/list-item";
const ProjectSelectorMenu = (_ref) => {
  let {
    selectedProjectName,
    onProjectSelected,
    i18n
  } = _ref;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-target-project-selector-container", "data-sentry-component": "ProjectSelectorMenu", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("span", { sel: ".mp-dashboard-selector-project-selector-menu-label" }, i18n.t("boards.selector.project")), /* @__PURE__ */ jsx(SelectEl, { sel: ".mp-dashboard-selector-project-selection", attrs: {
    "force-visibility": true,
    "menu-alignment": Directions.DownCenter,
    "selected-option": selectedProjectName || "",
    size: ButtonSize.Inline,
    theme: SelectTheme.MenuFilter
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { attrs: {
    slot: "body"
  } }, /* @__PURE__ */ jsx(TargetProjectSelectorMenuEl, { params: {
    isFeatureGateEnterpriseTier: true
  }, on: {
    projectSelected: onProjectSelected
  }, "data-sentry-element": "TargetProjectSelectorMenuEl", "data-sentry-source-file": "template.tsx" }))));
};
const MoveActionButton = (_ref2) => {
  let {
    onMoveBoard,
    isCurrentProjectSelected,
    isCrossProjectMoveEnabled,
    isNestedDashboardsEnabled,
    showMoveOutButton,
    i18n
  } = _ref2;
  let message = null;
  let disabled = false;
  let tooltipMessage = null;
  if (isCurrentProjectSelected && (isNestedDashboardsEnabled || showMoveOutButton)) {
    if (!showMoveOutButton) {
      return null;
    }
    message = i18n.t("boards.selector.move-out-all");
  } else if (isCrossProjectMoveEnabled) {
    message = /* @__PURE__ */ jsx(MarkdownEl, { attrs: {
      text: i18n.t("boards.selector.move-to-your-boards")
    } });
    disabled = isCurrentProjectSelected;
    tooltipMessage = isCurrentProjectSelected ? i18n.t("boards.selector.no-move-access") : null;
  }
  if (!message) {
    return null;
  }
  return /* @__PURE__ */ jsx(ListItemEl, { attrs: {
    "style-override": ".mp-list-item-container {padding:0}",
    disabled
  }, on: {
    click: disabled ? null : onMoveBoard
  }, "data-sentry-element": "ListItemEl", "data-sentry-component": "MoveActionButton", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-move-target-label", class: {
    "mp-dashboard-selector-disabled": disabled
  } }, message), tooltipMessage && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top,
    "max-width": "300px"
  } }, tooltipMessage));
};
const SearchableText = (_ref3) => {
  let {
    value,
    placeholder,
    searchTokens
  } = _ref3;
  return !value ? /* @__PURE__ */ jsx("i", null, placeholder) : searchTokens ? /* @__PURE__ */ jsx(null, null, searchTokens.map((token, pos) => pos % 2 === 1 ? token : /* @__PURE__ */ jsx("b", null, token))) : /* @__PURE__ */ jsx(null, null, value);
};
export function template() {
  var _this$helpers$getMove, _this$state$moveToTar;
  const {
    activeItem,
    busy,
    controller,
    creating,
    disableCreateDashboard,
    newTitle,
    open,
    searchFilter,
    sections
  } = this.state;
  const disabledTooltip = (item) => {
    const dashboardDisabledStatus = this.helpers.getDashboardDisabledStatus(item);
    const message = this.helpers.getMessageForDisabledStatus(dashboardDisabledStatus);
    if (message) {
      return /* @__PURE__ */ jsx(TooltipEl, { attrs: {
        placement: Placement.Top
      } }, message);
    }
    return null;
  };
  const isMovingDashboardToProjectWithoutFF = this.helpers.isNestedBoardsEnabled() && this.attr("enable-nested-dashboards-restrictions") && !this.state.isNestedBoardsEnabledForTargetProject;
  return /* @__PURE__ */ jsx(DropMenuEl, { attrs: _objectSpread({
    open,
    direction: this.attr("direction"),
    offset: this.attr("offset")
  }, this.attr("position-strategy") ? {
    "position-strategy": this.attr("position-strategy")
  } : {}), props: {
    positionParent: this
  }, on: {
    change: this.helpers.handleMenuChange,
    perfpoint: this.helpers.handlePerfPoint
  }, "data-sentry-element": "DropMenuEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-container" }, this.params.detailedExplainCopy && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-detailed-explain-copy-title" }, this.print(this.params.detailedExplainCopy.title)), /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-detailed-explain-copy-description" }, this.print(this.params.detailedExplainCopy.description))), !creating ? /* @__PURE__ */ jsx(null, null, this.attr("hide-dashboard-list") ? null : /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-search-container" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    icon: "search",
    placeholder: this.helpers.getSearchPlaceholder()
  }, on: {
    input: this.helpers.handleSearchInput
  }, props: {
    value: searchFilter
  }, hook: {
    insert: this.helpers.handleSearchInputInsertHook
  } })), this.helpers.isCrossProjectEnabled() && /* @__PURE__ */ jsx(ProjectSelectorMenu, { selectedProjectName: (_this$helpers$getMove = this.helpers.getMoveToTargetProject()) === null || _this$helpers$getMove === void 0 ? void 0 : _this$helpers$getMove.name, onProjectSelected: this.helpers.updateDashboardSelectorMenu, i18n: this.getContext("i18n") }), /* @__PURE__ */ jsx(MoveActionButton, { isCurrentProjectSelected: ((_this$state$moveToTar = this.state.moveToTargetProject) === null || _this$state$moveToTar === void 0 ? void 0 : _this$state$moveToTar.id.toString()) === this.getContext("currentProject").id, isCrossProjectMoveEnabled: this.helpers.isCrossProjectEnabled(), isNestedDashboardsEnabled: this.helpers.isNestedBoardsEnabled(), showMoveOutButton: this.attr("show-move-out-button"), onMoveBoard: this.helpers.moveBoard, i18n: this.getContext("i18n") }), this.attr("hide-dashboard-list") ? null : !(controller !== null && controller !== void 0 && controller.getLoaded()) ? /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-loading", class: {
    "mp-dashboard-selector-compact-mode": this.attr("compact-mode")
  } }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-items-container", class: {
    "mp-dashboard-selector-compact-mode": this.attr("compact-mode")
  } }, sections.length === 0 || sections.length === 1 && sections[0].items.length === 0 ? /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-empty-state" }, searchFilter ? this.t("boards.selector.no-boards-found") : this.t("boards.selector.no-boards")) : isMovingDashboardToProjectWithoutFF ? /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-empty-state" }, this.t("boards.selector.nested-disabled")) : sections.map((section, sectionIndex) => /* @__PURE__ */ jsx(null, null, sectionIndex !== 0 ? /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-divider" }) : null, /* @__PURE__ */ jsx("section", null, section.title && /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-section-header" }, section.title), section.items.map((item) => /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-item-row-wrapper" }, disabledTooltip(item), /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-item-row", key: item.dashboard.id, class: {
    "mp-dashboard-selector-active": activeItem && activeItem.dashboard.id === item.dashboard.id,
    "mp-dashboard-selector-disabled": this.helpers.getDashboardDisabledStatus(item) !== null
  }, on: {
    click: this.helpers.getItemActionHandler(item),
    mouseover: this.helpers.getItemMouseOverHandler(item)
  }, hook: {
    insert: this.helpers.handleItemRowInsertHook
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-text" }, /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-title", attrs: {
    title: item.dashboard.title
  }, class: {
    "mp-dashboard-selector-placeholder": !item.dashboard.title
  } }, /* @__PURE__ */ jsx(SearchableText, { value: item.dashboard.title, placeholder: "Untitled board", searchTokens: item.titleSearchTokens })), /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-sublabel", class: {
    "mp-dashboard-selector-placeholder": this.getDashboardSublabel(item.dashboard)
  } }, /* @__PURE__ */ jsx(SearchableText, { value: this.getDashboardSublabel(item.dashboard), placeholder: "No description", searchTokens: item.sublabelSearchTokens })))))))))), busy ? /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-busy" }, /* @__PURE__ */ jsx(SpinnerEl, null)) : creating ? /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-create-field" }, /* @__PURE__ */ jsx(InputGroupEl, { attrs: {
    placeholder: "New board title",
    busy
  }, on: {
    input: this.helpers.handleCreateInput,
    submit: this.helpers.handleCreateSubmit
  }, props: {
    value: newTitle
  }, hook: {
    insert: this.helpers.handleCreateInputInsertHook
  } })) : this.attr("quick-create") ? /* @__PURE__ */ jsx(ButtonBarEl, { attrs: {
    theme: ButtonBarTheme.Secondary
  }, on: {
    click: this.helpers.handleQuickCreateClick
  } }, this.helpers.getQuickCreateSaveText()) : !disableCreateDashboard && !isMovingDashboardToProjectWithoutFF ? /* @__PURE__ */ jsx(ButtonBarEl, { attrs: {
    theme: ButtonBarTheme.Secondary
  }, on: {
    click: this.helpers.handleCreateClick
  } }, this.t("boards.selector.create-new")) : this.attr("enable-management") ? /* @__PURE__ */ jsx(ButtonBarEl, { attrs: {
    theme: ButtonBarTheme.Secondary
  }, on: {
    click: this.helpers.handleManageClick
  } }, this.t("boards.selector.manage")) : null)) : /* @__PURE__ */ jsx("div", { sel: ".mp-dashboard-selector-new-dashboard-input" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    placeholder: this.helpers.getSearchPlaceholder()
  }, props: {
    value: this.t("boards.header.title-placeholder")
  }, on: {
    input: this.helpers.handleCreateInput
  }, hook: {
    insert: this.helpers.handleCreateInputInsertHook
  } }), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Primary,
    disabled: !newTitle
  }, on: {
    click: this.helpers.handleCreateSubmit
  } }, this.t("common.save")))));
}
